import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./components/error-page";
import type { FC } from "react";
import { lazy, Suspense } from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LaunchPage from "./pages/launch-page";
import AuthRedirectPage from "./pages/auth-redirect-page";
import FHIRContextProvider from "./contexts/FHIRContext/Provider";
import PatientEmbedPage from "./pages/patient-embed-page";
import PatientListPage from "./pages/patient-list-page";

const ArasPopoverMockDemoPage = lazy(
  () => import("./pages/aras-popover-mock-demo-page"),
);

// FHIR App Route wrapper
const FHIRAppRoute: FC = () => {
  return (
    <FHIRContextProvider>
      <AuthRedirectPage />
    </FHIRContextProvider>
  );
};

const App: FC = () => {
  const basename = process.env.REACT_APP_BASE_URL || "/patient-embed";
  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <Router basename={basename}>
        <Routes>
          <Route path="/" element={<PatientEmbedPage />} />
          <Route path="/list" element={<PatientListPage />} />
          {/* Future SMART on FHIR routes */}
          <Route path="/launch" element={<LaunchPage />} />
          <Route path="/app" element={<FHIRAppRoute />} />
          {process.env.NODE_ENV === "development" && (
            <Route
              path="/dev/aras-popover"
              element={
                <Suspense fallback={null}>
                  <ArasPopoverMockDemoPage />
                </Suspense>
              }
            />
          )}
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};
export default App;
